import { useState } from 'react';

const faqs = [
  {
    q: '91浏览器手机版从哪里下载比较稳妥？',
    a: '本页三个入口指向的是同一份安装包，区别只在安装方式。想省事就选「安卓版稳定直装」，想第一时间用上新内核就选「最新版」，网络不稳时可以先存「安装包」再手动安装。',
  },
  {
    q: '手机内存小，装完会不会更卡？',
    a: '这版在后台做了减法，常驻占用比旧版更克制。安装后建议在设置里关闭不必要的自启项，配合一次缓存清理，小内存机型同样能保持顺滑。',
  },
  {
    q: '看片总卡顿，换新版本有帮助吗？',
    a: '有帮助，但也要看网络。新版优化了视频页的加载与拖动响应，网络波动时会自动降档续播。如果依旧卡，先检查当前网络，再清理一次播放缓存。',
  },
  {
    q: '安装时提示来源不明，打不开怎么办？',
    a: '这是系统的安全拦截，不是安装包有问题。进入「设置 - 安全 - 安装未知应用」，为本页来源打开开关，返回后重新点安装即可继续。',
  },
  {
    q: '老用户升级会丢掉书签和历史记录吗？',
    a: '直接覆盖安装即可保留，无需先卸载。若你之前手动清除过应用数据，记录会受影响，建议升级前在设置里做一次备份，用不惯也能回退到旧版。',
  },
  {
    q: '最新版和安装包是同一份文件吗？',
    a: '内容一致，指向的都是当前的正式发布版本。安装包更适合离线、多设备分发；最新版入口则会在有新版本时提示更新，方便后续保持同步。',
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="text-center reveal reveal-1">
          <span className="text-xs md:text-sm font-medium text-accent-700 tracking-wide">
            常见问题
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            下载与安装，都在问这些
          </h2>
        </div>

        <div className="mt-10 md:mt-14 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          {faqs.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div key={item.q} className="border-b border-background-200 last:border-0">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-7 py-5 cursor-pointer"
                >
                  <span className="font-medium text-sm md:text-base text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-7 pb-6 -mt-1">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}